module.exports = { "default": require("core-js/library/fn/object/values"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/core-js/object/values.js
// module id = 109
// module chunks = 0